import React from 'react';
import { Alert } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const EnvironmentBanner: React.FC = () => {
    const environment = process.env.REACT_APP_ENVIRONMENT || '';
    const isProduction = !environment || environment.toLowerCase() === 'production';

    if (isProduction) {
        return null;
    }

    return (
        // Normal-flow banner at the top of the app, NOT sticky. It sat sticky at
        // zIndex 1001 and floated over AntD's overlay layer (Drawer / Modal /
        // popovers at zIndex 1000), intercepting clicks on drawer/modal controls
        // in the top strip. It can't simply drop below 1000 either: the app
        // Header is also sticky at top:0 with zIndex 1000, so a lower banner is
        // hidden behind the header on scroll. Keeping it in normal flow avoids
        // both — it shows at the top of every page and scrolls with the content,
        // never contesting the header's slot or the overlay layer.
        <Alert
            message={
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <WarningOutlined style={{ marginRight: 8 }} />
                    TEST ENVIRONMENT — This is not the live system. Any data entered here is for testing purposes only.
                    <WarningOutlined style={{ marginLeft: 8 }} />
                </div>
            }
            type="warning"
            banner
        />
    );
};

export default EnvironmentBanner;
